export default __webpack_public_path__ + "static/WordPressIcon-21c1031ac978f9b34a96f5455edf651b.svg";